import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useSplitFeatureFlag } from '@/hooks/useSplitFeatureFlag';
import { SplitFeatureFlag } from '@/utils/split/splitConfig';
import { Renter } from '../../utils/types/renter.interface';
import { renterSchema } from '../../utils/validator/RenterValidator';
import { RentCoverageTypes, SecurityDepositTypes } from '../../constants/CoverageType';

interface UseRenterInviteFormProps {
  selfEnrolledSDRLimit?: number;
  customCoverageDisabled?: boolean;
  useNewCoveragesOnLandlordInvite?: boolean;
}

const useRenterInviteForm = ({
  selfEnrolledSDRLimit,
  customCoverageDisabled,
  useNewCoveragesOnLandlordInvite,
}: UseRenterInviteFormProps) => {
  const { isFeatureFlagEnabled, isReady } = useSplitFeatureFlag(
    SplitFeatureFlag.MONARCH_446_SWAP_BUILDINGS_TO_PROPERTY_API,
  );
  const isNewPropertyApi = isReady && isFeatureFlagEnabled;

  const {
    control,
    handleSubmit,
    setError,
    watch,
    formState,
    setValue,
    trigger,
    resetField,
    clearErrors,
  } = useForm<Renter>({
    mode: 'all',
    resolver: yupResolver(
      renterSchema(
        selfEnrolledSDRLimit,
        customCoverageDisabled,
        useNewCoveragesOnLandlordInvite,
        isNewPropertyApi,
      ),
    ),
    defaultValues: {
      apartmentNumber: '',
      approvalStatus: '',
      customCoverage: false,
      applicantEmails: [{ value: '' }],
      securityDepositCoverage: SecurityDepositTypes.CompanyDefault,
      rentCoverage: RentCoverageTypes.CompanyDefault,
    },
    shouldUnregister: true,
  });

  return {
    control,
    formState,
    setError,
    handleSubmit,
    watch,
    setValue,
    trigger,
    resetField,
    clearErrors,
  };
};

export default useRenterInviteForm;
